import { useState, useEffect } from 'react';

/**
 * Custom hook that debounces a value
 * @param {any} value - The value to debounce
 * @param {number} delay - The delay in milliseconds
 * @returns {any} The debounced value
 */
export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

/**
 * Custom hook for debounced search with loading state
 * @param {string} searchTerm - The search term
 * @param {number} delay - The delay in milliseconds (default: 300)
 * @returns {object} { debouncedSearchTerm, isSearching }
 */
export function useDebouncedSearch(searchTerm, delay = 300) {
  const debouncedSearchTerm = useDebounce(searchTerm, delay);
  // isSearching is purely derived — no state or effect needed, avoids an extra render cycle
  return {
    debouncedSearchTerm,
    isSearching: searchTerm !== debouncedSearchTerm
  };
}